import { render } from "./RelationsForm.vue?vue&type=template&id=121d8f04&scoped=true"
import script from "./RelationsForm.vue?vue&type=script&lang=js"
export * from "./RelationsForm.vue?vue&type=script&lang=js"

import "./RelationsForm.vue?vue&type=style&index=0&id=121d8f04&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121d8f04"]])

export default __exports__